import { ChangeEvent, FC, memo } from "react";
import styles from "./checkbox.module.scss";

interface CheckboxProps {
  name: string;
  value?: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
  id?: string;
}

export const Checkbox: FC<CheckboxProps> = memo(
  ({ name, checked, value, onChange, isDisabled, id = name + value }) => {
    return (
      <div className={styles.container} data-is-disabled={isDisabled}>
        <input
          type="checkbox"
          className={styles.input}
          name={name}
          checked={checked}
          onChange={onChange}
          id={id}
          disabled={isDisabled}
          value={value}
        />
        <label htmlFor={id} className={styles.label}>
          <span className={styles.mark}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 11 8"
              fill="none"
            >
              <path
                d="M9.62922 1.40145L4.67947 6.3512C4.28895 6.74172 3.65578 6.74172 3.26526 6.3512L0.5 3.58594"
                stroke="currentColor"
                strokeLinecap="round"
              />
            </svg>
          </span>
        </label>
      </div>
    );
  },
);
